import classNames from 'classnames';
import React, { useId, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { inputClassNames, sizes, hintClassNames, labelClassNames } from './Input';

export const PasswordInput = ({ className, size = 'default', label, hint, id, ...rest }) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  const generatedId = useId();
  const inputId = id ?? generatedId;

  const togglePasswordVisibility = () => setShowPassword((v) => !v);

  return (
    <>
      {label && (
        <div className={labelClassNames}>
          <label htmlFor={inputId}>{label}</label>
          {hint && <span className={hintClassNames}>{hint}</span>}
        </div>
      )}
      {/* Shares inputClassNames with Input so the two can't drift again. The wrapper owns
          the chrome, so focus is focus-within: and the inner input is bare. */}
      <div className={classNames(
        inputClassNames,
        'relative flex items-center focus-within:border-ui-accent',
        sizes[size],
        className,
      )}>
        <input
          id={inputId}
          type={showPassword ? 'text' : 'password'}
          className="w-full bg-transparent pr-6 text-ui placeholder:text-ui-4 focus:outline-none disabled:cursor-not-allowed disabled:text-ui-3"
          {...rest}
        />
        <button
          type="button"
          onClick={togglePasswordVisibility}
          className="absolute right-1 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded text-ui-3 transition-colors duration-150 hover:text-ui-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-ui-accent-ring"
          disabled={rest.disabled}
          aria-label={t(showPassword ? 'fields.hidePassword' : 'fields.showPassword')}
          aria-pressed={showPassword}
        >
          {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      </div>
    </>
  );
};
